import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import GetReceiptCheckboxWithInput from '../../common/GetReceiptCheckboxWithInput';
import Button from '../../ui/Button';
import CustomScrollWrap from '../../ui/CustomScrollWrap';
import Form from '../../ui/Form';

const thisTabKey = 'best_to_pay';

class Best2Pay extends React.PureComponent {
  static propTypes = {
    app: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    formData: PropTypes.object.isRequired,
    sessionId: PropTypes.string.isRequired,
    initPayment: PropTypes.func.isRequired,
    methodConfig: PropTypes.object.isRequired,
    onStepDidMount: PropTypes.func.isRequired,
    getExtraData: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.scroll = React.createRef();
    this.thisMethod = this.props.app.payMethods.best_to_pay;

    this.state = {
      loading: false,
    };
  }

  componentDidMount() {
    this.props.onStepDidMount();
  }

  universalValidator = (value, validatorConfig, field) => {
    if (!validatorConfig) return '';

    const { formData, methodConfig, t } = this.props;

    if (field === 'receiptEmail') {
      if (formData.getReceipt && !methodConfig.hideReceiptField) {
        if (!value.trim()) return t('common.field_required');

        const regexp = new RegExp(validatorConfig.regexp);

        if (!regexp.test(value)) {
          return validatorConfig.regexpErrorMsg ? validatorConfig.regexpErrorMsg : t('common.field_invalid');
        }
      }
      return '';
    }

    if (validatorConfig.required && !value.trim()) {
      return t('common.field_required');
    }

    if (validatorConfig.regexp && !!value.trim()) {
      const regexp = new RegExp(validatorConfig.regexp);

      if (!regexp.test(value.trim())) {
        return validatorConfig.regexpErrorMsg ? validatorConfig.regexpErrorMsg : t('common.field_invalid');
      }
    }

    return '';
  };

  onSubmit = () => {
    const {
      data: { payment: { amount, currency, exponent } },
      getExtraData,
      formData,
      formData: { getReceipt },
      sessionId,
      initPayment,
      methodConfig: { hideReceiptField },
    } = this.props;

    const extra = {
      ...getExtraData({ methodUrl: 'best_to_pay' }),
      redirectFormTarget: this.thisMethod.redirectFormTarget || '_self',
    };

    if (getReceipt && !hideReceiptField) {
      extra.receiptEmail = formData.receiptEmail;
    }

    const paymentData = {
      payment: { amount, currency, exponent },
      payer: { cls: 'best_to_pay' },
      extra,
      ...(formData.getReceipt && !hideReceiptField ? { receiptEmail: formData.receiptEmail } : null),
    };

    this.setState({ loading: false });

    initPayment(paymentData)
      .then(() => {
        const { data: { tx }, history } = this.props;
        history.push(`/${sessionId}/pending/${tx.id}`);
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  }

  render() {
    const { loading } = this.state;
    const { formData: { getReceipt, receiptEmail }, methodConfig: { hideReceiptField } } = this.props;

    return (
      <div className="content-block-body pay-method-step">
        <Form className="bnpl-form" onSubmit={this.onSubmit} key={thisTabKey} disabled={loading}>
          <div className={classnames('ui-scroll-outer', { 'no-receipt-field': hideReceiptField })}>
            <CustomScrollWrap ref={this.scroll}>
              <div className="ui-scroll-inner">
                <div className="method-help-text" dangerouslySetInnerHTML={{ __html: this.thisMethod.helpText }} />
              </div>
            </CustomScrollWrap>
          </div>
          <div className="form-footer">
            <GetReceiptCheckboxWithInput hidden={hideReceiptField} onValidate={this.universalValidator} />
            <Button
              type="submit"
              label={this.thisMethod.submitBtnText}
              disabled={getReceipt && !hideReceiptField && !receiptEmail}
              loading={loading}
            />
          </div>
        </Form>
      </div>
    );
  }
}

export default withTranslation()(Best2Pay);
